import { accountsAtom } from 'atoms';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { Account } from 'types/Account';

function useGetAccountById(accountId: number): Account | null {
  const accounts = useRecoilValue(accountsAtom);

  const account = useMemo(
    () => accounts?.find((account) => account.id === Number(accountId)) || null,
    [accounts, accountId],
  );

  return account;
}

export default useGetAccountById;
